<template lang="html">
	<v-error type="403"></v-error>
</template>

<script>

import Error from '@/components/common/error/Error.vue';

export default {
	name : 'Page404',
	components : {
		'v-error' : Error
	}
}
</script>



// WEBPACK FOOTER //
// src/components/403/403.vue